import { defineMessages } from 'react-intl';
import type { IntlShape } from '@plone/types/src/i18n';

type MainContentReaderSchemaArgs = {
  props: unknown;
  intl: IntlShape;
};

const messages = defineMessages({
  blockTitle: {
    id: 'Main content reader block',
    defaultMessage: 'Leitor do conteudo principal',
  },
  align: {
    id: 'Alignment',
    defaultMessage: 'Alinhamento',
  },
});

export const MainContentReaderBlockSchema = ({
  intl,
}: MainContentReaderSchemaArgs): any => {
  return {
    title: intl.formatMessage(messages.blockTitle),
    fieldsets: [
      {
        id: 'default',
        title: 'default',
        fields: ['align'],
      },
    ],
    properties: {
      align: {
        title: intl.formatMessage(messages.align),
        widget: 'align',
        default: 'center',
      },
    },
    required: [],
  };
};
